import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    this.email = 'nbjmup;jogpAtuvejp.tdbmf/dpn'
    this.decodedEmail = this.unCryptMailto(this.email)
    this.el.innerHTML = this.decodedEmail.replace('@', '<!---->@<!---->').replace('mailto:', '')
    this.el.href = `${this.decodedEmail}`
  }

  unCryptMailto(s) {
    let r = ''
    for (let i = 0; i < s.length; i += 1) {
      const n = s.charCodeAt(i)
      r += String.fromCharCode(n - 1)
    }
    return r
  }
}
